"use client";

import Link from "next/link";
import Box from "@mui/material/Box";

export default function BoxLink({ href, title }) {
  return (
    <Link href={href} prefetch={false} style={{ textDecoration: 'none' }}>
      <Box
        component="span"
        fontWeight={500}
        borderColor="grey.900"
        borderBottom="1px solid"
        sx={{
          cursor: "pointer",
          color: "inherit",
          "&:hover": {
            opacity: 0.8
          }
        }}
      >
        {title}
      </Box>
    </Link>
  );
}